import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchJournalEntry } from "../lib/api";
import { ArrowLeft } from "lucide-react";
import { JsonLd, articleSchema } from "../components/JsonLd";

export default function JournalEntry() {
    const { slug } = useParams();
    const [entry, setEntry] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        window.scrollTo({ top: 0, behavior: "instant" });
        fetchJournalEntry(slug)
            .then(setEntry)
            .catch(() => setEntry(null))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="pt-32 container-rail min-h-[60vh]" />;
    if (!entry) {
        return (
            <div className="pt-32 container-rail text-center py-20">
                <p className="text-overline text-[#A3A3A3]">Entry not found.</p>
                <Link to="/journal" className="btn-ghost mt-6 inline-flex">Back to Journal</Link>
            </div>
        );
    }

    return (
        <div data-testid="journal-entry-page" className="pt-24">
            <JsonLd data={articleSchema(entry)} />
            <div className="container-rail py-6">
                <Link to="/journal" className="text-overline text-[#A3A3A3] hover:text-[#F4F4F0] inline-flex items-center gap-2">
                    <ArrowLeft className="h-3 w-3" /> Back to Journal
                </Link>
            </div>

            <article className="container-rail max-w-3xl mx-auto pb-24">
                <div className="text-overline text-[#A3A3A3] mb-4">{entry.chapter} · {entry.date}</div>
                <h1 className="text-display text-5xl sm:text-6xl md:text-7xl leading-[0.92] mb-8">
                    {entry.title}
                </h1>
                <p className="text-[#A3A3A3] text-lg leading-relaxed italic mb-10">{entry.excerpt}</p>

                <div className="relative aspect-[16/9] overflow-hidden bg-[#141414] border border-white/[0.06] mb-10">
                    <img src={entry.cover} alt={entry.title} className="h-full w-full object-cover" />
                </div>

                <div className="space-y-6 text-[#D6D6CC] text-[17px] leading-relaxed font-light">
                    {entry.body.split("\n\n").map((para, i) => (
                        <p key={`${entry.slug}-p-${i}-${para.slice(0, 24)}`}>{para}</p>
                    ))}
                </div>

                <div className="mt-16 pt-6 border-t border-white/10 text-overline text-[#666]">
                    — {entry.author}
                </div>
            </article>
        </div>
    );
}
